import { Toaster as Sonner } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
    return (
        <Sonner
            className="toaster group"
            position="bottom-center"
            toastOptions={{
                classNames: {
                    toast:
                        "group toast bg-[var(--card-bg)] text-[var(--text-primary)] border-[var(--border-color)] shadow-lg",
                    description: "group-[.toast]:text-[var(--text-secondary)]",
                    actionButton:
                        "group-[.toast]:bg-[var(--neon-blue)] group-[.toast]:text-white",
                    cancelButton:
                        "group-[.toast]:bg-[var(--bg)] group-[.toast]:text-[var(--text-secondary)]",
                },
            }}
            {...props}
        />
    )
}

export { Toaster }
